<template>
  <div class="w-full">
    <VOtpInput
      v-model:value="otpInput"
      :num-inputs="4"
      @on-change="(value) => emit('on-change', value)"
      @on-complete="(value) => emit('on-complete', value)"
      input-classes="otp-input"
      :inputmode="'numeric'"
    />
  </div>
</template>

<script setup lang="ts">
import VOtpInput from 'vue3-otp-input'

const emit = defineEmits(['on-change', 'on-complete'])
const otpInput = defineModel<string>()
</script>

<style lang="postcss">
.otp-input-container {
  @apply gap-3;
}
</style>
